import {
  GET_ROTATE_STATUS,
  SET_ROTATE_STATUS,
} from "../constants/rotate-constants";

const initialState = {
  status: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ROTATE_STATUS:
      const { status } = action;
      return { ...state, status };
    default:
      return state;
  }
};
